import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="minimal-footer">
      <p>&copy; 2025 Ștefan Lică</p>
    </footer>
  );
};

export default Footer;
